import { StoreType } from '@tock/shared/utils/connect';
import { UserConsentLevel } from '@tock/shared/utils/cookieConsentUtils';
import { createSelector } from 'reselect';

const cookieConsent = (state: StoreType) => state.cookieConsent;

export const consentLevelFunctionalSelector = createSelector(cookieConsent, (cookieConsent) =>
  cookieConsent.consentLevel.includes(UserConsentLevel.FUNCTIONAL)
);

export const consentLevelAdvertisingSelector = createSelector(cookieConsent, (cookieConsent) =>
  cookieConsent.consentLevel.includes(UserConsentLevel.ADVERTISING)
);

export const googleAnalyticsScriptsLoadedSelector = createSelector(
  cookieConsent,
  (cookieConsent) => cookieConsent.googleAnalyticsScriptsLoaded
);

export const amplitudeScriptsLoadedSelector = createSelector(
  cookieConsent,
  (cookieConsent) => cookieConsent.amplitudeScriptsLoaded
);
